import React from 'react';
import { Button, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './EmptyState.css';

/**
 * Why a list is empty and the one next step. `action` is { label, to } for a
 * link or { label, onClick } for a button; omit it when there is no step.
 */
function EmptyState({ message, action }) {
    return (
        <Card className="border-0 bg-light">
            <Card.Body className="text-center py-5">
                <p
                    className={`text-body-secondary ${action ? 'mb-3' : 'mb-0'}`}
                >
                    {message}
                </p>
                {action &&
                    (action.to ? (
                        <Button
                            as={Link}
                            to={action.to}
                            variant="primary"
                            className="empty-state-action"
                        >
                            {action.label}
                        </Button>
                    ) : (
                        <Button
                            variant="primary"
                            className="empty-state-action"
                            onClick={action.onClick}
                        >
                            {action.label}
                        </Button>
                    ))}
            </Card.Body>
        </Card>
    );
}

export default EmptyState;
